import { t } from '@trimble/i18n';
import { JSX } from 'solid-js';
import type { VolumeMeasurementType } from '@trimble/web3d-providers';

export interface VolumetricMeasurementOptionsProps {
  measurement: VolumeMeasurementType;
}

export const VolumetricMeasurementOptions = (
  props: VolumetricMeasurementOptionsProps
): JSX.Element => {
  const getSurfaceDisplayName = (
    parameters: VolumeMeasurementType['parameters'] | undefined,
    which: 'from' | 'to'
  ): string => {
    if (!parameters) {
      return '';
    }
    const name =
      which === 'from' ? parameters.fromSurfaceName : parameters.toSurfaceName;
    const id =
      which === 'from' ? parameters.fromSurfaceId : parameters.toSurfaceId;

    return name ?? id ?? '';
  };

  return (
    <div class="flex flex-col gap-4 py-2">
      <div class="flex flex-col px-4">
        <span class="text-xs text-gray-500">
          {t('measurements.volumetric.volumeType')}
        </span>
        <span class="text-base text-gray-800">
          {t('measurements.volumetric.surfaceToSurface')}
        </span>
      </div>

      <div class="flex flex-col px-4">
        <span class="text-xs text-gray-500">
          {t('measurements.volumetric.fromSurface')}
        </span>
        <p class="text-base text-gray-800 break-words">
          {getSurfaceDisplayName(
            (props.measurement as VolumeMeasurementType | undefined)
              ?.parameters,
            'from'
          )}
        </p>
      </div>

      <div class="flex flex-col px-4">
        <span class="text-xs text-gray-500">
          {t('measurements.volumetric.toSurface')}
        </span>
        <p class="text-base text-gray-800 break-words">
          {getSurfaceDisplayName(
            (props.measurement as VolumeMeasurementType | undefined)
              ?.parameters,
            'to'
          )}
        </p>
      </div>

      <div class="flex flex-col px-4">
        <span class="text-xs text-gray-500">
          {t('measurements.volumetric.boundary')}
        </span>
        <span class="text-base text-gray-800">
          {props.measurement?.parameters?.boundaryInclusive
            ? t('measurements.volumetric.customBoundary')
            : t('measurements.volumetric.noBoundary')}
        </span>
      </div>
    </div>
  );
};
